import React from 'react'
import withFormState from 'src/components/aciacehighway/hocs/withFormState';
import { ScopedCssBaseline } from '@mui/material';
import pathMap from 'src/paths/pathMap';
import EditSKUMgmt from '../component/sku-mgmt-form/edit/EditSKUMgmt';

function EditPage({ history, match: { params } }) {

  return (<ScopedCssBaseline>
    <EditSKUMgmt id={params.id} onClose={() => history.push(pathMap.ABI_SKU_MGMT_LIST_VIEW)} />
  </ScopedCssBaseline>);
}

export default withFormState(EditPage)
